(function () {
  'use strict';

  /* @ngdoc object
   * @name configureTrackingColor
   * @description
   *
   */
  angular
    .module('configureTrackingColor', [
      'ui.router'
    ]);
}());
